/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Tags_HelpInputs */

const en_editor_tags_help = /** @type {(inputs: Editor_Tags_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separated by commas`)
};

const de_editor_tags_help = /** @type {(inputs: Editor_Tags_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Kommas getrennt`)
};

/**
* | output |
* | --- |
* | "Separated by commas" |
*
* @param {Editor_Tags_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_tags_help = /** @type {((inputs?: Editor_Tags_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Tags_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_tags_help(inputs)
	return en_editor_tags_help(inputs)
});